<template>
  <svg viewBox="0 0 600 600" :class="{ active: changeColor }">
    <path
      d="M545.79,339.84l-8.07-8.07c-3.15-3.15-8.25-3.15-11.4,0l-90.22,90.22L205.2,191.09c-.35-.46-.73-.9-1.15-1.31-2.71-2.71-6.26-4.05-9.81-4.03-3.55-.02-7.1,1.32-9.81,4.03h0c-.42,.42-.8,.86-1.15,1.31l-125.05,125.05c-5.3,5.3-5.63,13.94-.47,19.39s14.27,5.74,19.73,.28l116.75-116.75,231.69,231.69c1.33,1.33,2.87,2.33,4.51,3.01,5.1,2.39,11.36,1.48,15.57-2.73l99.78-99.78c3.15-3.15,3.15-8.25,0-11.4Z"
    />
    <path
      d="M125.54,251.58h10.52c4.69,0,8.5,3.81,8.5,8.5v189.29c0,7.6-6.17,13.76-13.76,13.76h0c-7.6,0-13.76-6.17-13.76-13.76v-189.29c0-4.69,3.81-8.5,8.5-8.5Z"
      transform="translate(291 12.18) rotate(45)"
    />
    <path
      d="M545.79,173.68l-8.07-8.07c-3.15-3.15-8.25-3.15-11.4,0l-90.22,90.22-100.61-100.61c-.35-.46-.73-.9-1.15-1.31h0c-1.71-1.71-3.75-2.87-5.91-3.49-4.71-1.45-10.05-.31-13.78,3.42h0c-.58,.58-1.09,1.19-1.54,1.84l-50.16,50.16c-3.2,3.2-3.2,8.4,0,11.6l7.86,7.86c3.2,3.2,8.4,3.2,11.6,0l42.12-42.12,101.39,101.39c1.33,1.33,2.87,2.33,4.51,3.01,5.1,2.39,11.36,1.48,15.57-2.73l99.78-99.78c3.15-3.15,3.15-8.25,0-11.4Z"
    />
    <path
      d="M536.24,522.48H77.52V64.12c0-7.06-5.18-13.26-12.2-14.04-8.3-.92-15.33,5.56-15.33,13.67v472.48h0c0,7.6,6.16,13.76,13.76,13.76h472.48c7.6,0,13.76-6.16,13.76-13.76h0c0-7.6-6.16-13.76-13.76-13.76Z"
    />
  </svg>
</template>

<script>
export default {
  props: {
    changeColor: {
      required: true,
    },
  },
}
</script>

<style scoped lang="scss">
svg {
  path {
    fill: $white;
  }
  &.active path {
    fill: $white;
  }
}

.light svg {
  path {
    fill: $gray-6;
  }

  &.active path {
    fill: $white;
  }
}
</style>
